import FinancialsTemplateFieldsFragment from "components/financials/modern/graphql/fragments/FinancialsTemplateFieldsFragment";
import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";
import gql from "graphql-tag";

export default gql`
  query FinancialsSheet(
    $vertical: PlatformVertical = STOCKS
    $statementType: FinancialsStatementType
    $tickerSymbol: TickerSymbol!
    $country: SecurityCountry!
    $currency: String = "USD"
    $limit: Int = 3
    $limitCriterion: FinancialsSheetLimitCriterion
    $financialsTemplate: FinancialsTemplateID
    $indicators: [IndicatorID!]
    $indicatorsCriterion: FinancialsSheetIndicatorsCriterion
    $filterByReportDateAfter: Date
    $filterByReportDateBefore: Date
    $filterByInterim: String
    $indicatorDataSource: IndicatorDataSource
    $indicatorsPlacement: IndicatorsTablePlacement = END
  ) {
    financialsSheet(
      vertical: $vertical
      statementType: $statementType
      tickerSymbol: $tickerSymbol
      country: $country
      currency: $currency
      limit: $limit
      limitCriterion: $limitCriterion
      indicators: $indicators
      indicatorsCriterion: $indicatorsCriterion
      financialsTemplate: $financialsTemplate
      filterByReportDateAfter: $filterByReportDateAfter
      filterByReportDateBefore: $filterByReportDateBefore
      filterByInterim: $filterByInterim
      indicatorDataSource: $indicatorDataSource
      indicatorsPlacement: $indicatorsPlacement
    ) {
      statementType
      reportDates
      interim
      isTrailingTwelveMonths
      isPreliminaryTrailingTwelveMonths
      isQuarterly
      isAnnual
      financialsCurrency
      requestedCurrency
      forexRates {
        asOfDate
        baseCurrency
        quoteCurrency
        price
      }
      context {
        ... on FinancialsSheetSECContextItem {
          accessionNumber
          formType
          filedAt
          linkToDetails
          linkToHighlights
        }
      }
      systemTemplate {
        ...FinancialsTemplateFields
        indicators {
          ...IndicatorFields
        }
      }
      overridingTemplate {
        ...FinancialsTemplateFields
        indicators {
          ...IndicatorFields
        }
      }
      viewerSelectedTemplate {
        ...FinancialsTemplateFields
        indicators {
          ...IndicatorFields
        }
      }
      indicators {
        objectId
        kind
        category
        dataSource
        preferredDocumentation {
          languageCode
          name
          abbreviation
          description
        }
        documentation {
          languageCode
          name
          abbreviation
          description
        }
        numberFormatOptions {
          style
          notation
          compactDisplay
          minimumFractionDigits
          maximumFractionDigits
          minimumSignificantDigits
          maximumSignificantDigits
          minimumIntegerDigits
        }
        columnTheme {
          textColor
          backgroundColor
        }
        vertical
        viewerCanSee
        series {
          theme {
            backgroundColor
            textColor
            formatting
          }
          formattedValue
          ... on FinancialIndicatorSeriesFinancialNode {
            value
          }
          ... on FinancialIndicatorSeriesCurrencyNode {
            value
          }
          ... on FinancialIndicatorSeriesNumberNode {
            value
          }
          ... on FinancialIndicatorSeriesPercentNode {
            value
          }
          ... on FinancialIndicatorSeriesRatioNode {
            value
          }
          ... on FinancialIndicatorSeriesMetricNode {
            value
          }
          ... on FinancialIndicatorSeriesTextNode {
            text
          }
        }
      }
    }
  }

  ${FinancialsTemplateFieldsFragment}
  ${IndicatorFieldsFragment}
`;
